<div fxLayout="column" fxLayoutAlign="center center" class="w-100 h-100 mat-elevation-z10" *ngIf="!showOTPForm">
    <h1 mat-dialog-title> Gestione OTP</h1>
    <form [formGroup]="entityFormGroup" fxFlexAlign="center center">
      <mat-card class="mat-elevation-z10">
        <mat-card-actions fxLayoutAlign="center" fxLayoutGap="16px" fxLayoutGap.xs="0px" *ngIf="data.user">
          <button
            mat-flat-button
            (click)="clodeDialog()"
            type="button"
          >
            Annulla
          </button>
          <button
            mat-flat-button
            color="primary"
            (click)="generateOtp()"
            type="button"
          >
            Genera QR Per l'OTP
          </button>
          <button
            mat-flat-button
            color="warn"
            (click)="disableOtp()"
            type="button"
          >
            Disattiva l'OTP
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
</div>
<div fxLayout="column" fxLayoutAlign="center center" class="w-100 h-100" *ngIf="showOTPForm">
  <h1 mat-dialog-title> Validazione OTP</h1> 
   <form [formGroup]="otpFormGroup" fxFlexAlign="center center">
      <mat-card class="mat-elevation-z10">
        <mat-card-content fxLayout="column">
          <!--QR code for otp-->
          <img
                *ngIf="qrImageUrl"
                [src]="qrImageUrl"
                width="200"
                height="200"
                style="margin-bottom: 20px;"
            />

          <mat-form-field appearance="fill">
            <mat-label>Codice OTP</mat-label>
            <input matInput type="text" maxlength="6" inputmode="numeric" formControlName="otp_code"/>
            <mat-error *ngIf="otpFormGroup.get('otp_code')?.hasError('required')">Obbligatorio</mat-error>
            <mat-error *ngIf="otpFormGroup.get('otp_code')?.hasError('pattern')">
              Formato Codice OTP non valido Es: 123456
            </mat-error>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions fxLayoutAlign="center">
          <button
            mat-flat-button
            color="primary"
            (click)="confirmOtp()"
            type="button"
          >
            Valida l'OTP
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
</div>